import { initialSettingsValue } from '@/app/(app-layout)/aibot/[chatbotId]/(layout)/settings/data';
import { SettingData } from '@/app/(app-layout)/aibot/[chatbotId]/(layout)/settings/types';

export const getChatbotSettings = (settings?: SettingData): SettingData => {
  return {
    ...initialSettingsValue,
    ...(settings || {}),
  };
};
